@use './common' as common;

.intro_v3 {
    @include common.main;

    color: white;

    .media_container {
        width: 100%;
        height: 100%;
    }
}
